import { mapMultiItemContextInput } from 'stores/adapters/bex-api/search/multi-item/multi-item-context-adapter';

import { MultiItemContext } from 'models/multi-item/multi-item-types';

import { ShoppingContextInput } from '__generated__/api';

export const getShoppingContextInput = (multiItemContext?: MultiItemContext): ShoppingContextInput | null => ({
  multiItem: mapMultiItemContextInput(multiItemContext),
});
